import React, { useEffect, useState } from 'react';

import classNames from 'classnames';

import Dropzone from 'react-dropzone'

import { FormFieldBase } from './';

import ValidationMessage from './validation-message';
import { AlertBanner } from '@legwork/react-ui-components';
import appConstant, { STORAGE_SERVICE_ROOT } from 'src/constants/app.constant';
import { httpRequest } from './helpers';
import ApiService from 'src/services/api.service';

var PropTypes = require('prop-types');

export const FormFieldPatientAttachment = ({
    id,
    form,
    field,
    commonProps,
    isRenderedField,
    onChange,
    value,
    validationMessage,
    readOnly,
    className,
    isPreview,
}) => {
    const [file, setFile] = useState()
    const [upload, setUpload] = useState()

    const [label, setLabel] = useState('')
    const [sublabel, setSublabel] = useState('')

    const [error, setError] = useState(null)

    const classes = classNames({
        [className]: true,
        'control-group error': validationMessage,
    });

    const [tenantInformation, setTenantInformation] = useState({

    })

    async function getDownloadUrl(file) {
        const formData = new FormData()

        formData.append('file', file)

        const result = await fetch(`${STORAGE_SERVICE_ROOT}public/patient-attachments/attachments?accountId=${tenantInformation.accountId}`, {
            method: 'POST',
            body: formData,
        })

        const data = await result.json()

        return data?.key
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setTenantInformation(JSON.parse(window.localStorage.getItem('tenantInfo')))
        }
    }, [])

    useEffect(() => {
        let labelMatch = (field?.properties?.common)?.find(prop => prop[0] === 'label')?.[1]?.value ||
            (field?.properties?.specific)?.find(prop => prop[0] === 'label')?.[1]?.value

        let subLabelMatch = (field?.properties?.common)?.find(prop => prop[0] === 'sublabel')?.[1]?.value ||
            (field?.properties?.specific)?.find(prop => prop[0] === 'sublabel')?.[1]?.value

        setLabel(labelMatch)
        setSublabel(subLabelMatch)
    }, [
        field
    ])

    useEffect(() => {
        setUpload(value)
    }, [
        value
    ])

    useEffect(() => {
        if (!file) return

        const formData = new FormData();
        formData.append('file', file);

        var type = 'patient-attachment';
        var fileName = file.name;
        var fileType = file.type;
        var fileSize = file.size;

        // Cast the binary file to a base64 string
        const reader = new FileReader();

        if (file.type === 'application/pdf') {
            convertPDFToImage(file).then(
                (pngFile) => {
                    getDownloadUrl(pngFile)
                        .then((response) => {
                            onChange({
                                target: {
                                    id: field.uuid,
                                    value: JSON.stringify({
                                        key: response,
                                        file: pngFile,
                                        type: type,
                                        fileName: fileName,
                                        fileType: fileType,
                                        fileSize: fileSize,
                                    }),
                                }
                            })
                        })
                }
            )

            return
        } else {
            getDownloadUrl(file)
                .then((response) => {
                    onChange({
                        target: {
                            id: field.uuid,
                            value: JSON.stringify({
                                key: response,
                                file: file,
                                type: type,
                                fileName: fileName,
                                fileType: fileType,
                                fileSize: fileSize,
                            }),
                        }
                    })
                })
        }
    }, [
        file
    ])

    useEffect(() => {
        if (typeof value === 'string' && !!value) {
            try {
                setUpload(
                    JSON.parse(value)
                )
            } catch (e) {
                console.error(e)
            }
        }
    }, [
        value
    ])

    const clear = () => {
        setFile(null)
        setUpload(null)

        let event = {
            target: {
                id: field.uuid,
                value: null,
            },
        };

        onChange(event);
    }

    const dropzoneRef = React.createRef()

    useEffect(() => {
        // Load PDF.js
        if (typeof window !== 'undefined' && !window.pdfjsLib) {
            const script = document.createElement('script')

            script.type = 'module'
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.5.136/pdf.min.mjs'
            script.async = true

            script.onload = () => {
                window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.5.136/pdf.worker.min.mjs'
            }

            document.body.appendChild(script)
        }
    }, [])

    async function convertPDFToImage(
        pdfFile,
        stitchDirection = 'horizontal',
        scale = 2.0
    ) {
        const pdf = await window.pdfjsLib.getDocument(URL.createObjectURL(pdfFile)).promise

        let totalHeight = 0,
            totalWidth = 0,
            maxWidth = 0,
            maxHeight = 0

        const pageCanvases = []

        for (let pageNum = 1; pageNum <= Math.min(pdf.numPages, 10); pageNum++) {
            const page = await pdf.getPage(pageNum)
            const viewport = page.getViewport({
                scale,
            })

            const canvas = document.createElement('canvas')
            const context = canvas.getContext('2d')

            canvas.height = viewport.height
            canvas.width = viewport.width

            await page.render({
                canvasContext: context,
                viewport
            })
                .promise

            pageCanvases.push(canvas)

            maxWidth = Math.max(maxWidth, canvas.width)
            maxHeight = Math.max(maxHeight, canvas.height)

            totalWidth += canvas.width
            totalHeight += canvas.height
        }

        const stitchCanvas = document.createElement('canvas')

        if (stitchDirection === 'vertical') {
            stitchCanvas.width = maxWidth
            stitchCanvas.height = totalHeight
        } else {
            stitchCanvas.width = totalWidth
            stitchCanvas.height = maxHeight
        }

        let currentPosition = 0

        const stitchContext = stitchCanvas.getContext(
            '2d'
        )

        for (const canvas of pageCanvases) {
            if (stitchDirection === 'vertical') {
                stitchContext.drawImage(
                    canvas,
                    0,
                    currentPosition,
                    canvas.width,
                    canvas.height
                )
                currentPosition += canvas.height
            } else {
                stitchContext.drawImage(
                    canvas,
                    currentPosition,
                    0,
                    canvas.width,
                    canvas.height
                )
                currentPosition += canvas.width
            }
        }

        return new Promise((resolve) => {
            stitchCanvas.toBlob((blob) => {
                const filename = 'PDF-Stitched.png'
                const pngFile = new File([blob], filename, { type: 'image/png' })

                resolve(pngFile)
            }, 'image/png')
        })
    }


    return <>
        <div
            className={classes}
        >
            <div className="form-field-label primary">
                {label} {commonProps.makeRequired ? '*' : ''}
            </div>

            {error && (
                <AlertBanner severity="error" style={{ display: error ? 'block' : 'none' }}>
                    {error}
                </AlertBanner>
            )}

            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '150px',
                }}
            >
                <a
                    style={{
                        backgroundColor: '#3E67C7',
                        color: 'white',
                        border: 'none',
                        padding: '10px',
                        borderRadius: '5px',
                        marginTop: '10px',
                        textAlign: 'center',
                        textDecoration: 'none',
                        marginBottom: '15px',
                        cursor: 'pointer',
                    }}
                    onClick={() => {
                        dropzoneRef.current.open()
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 15,
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-file">
                            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                            <polyline points="14 2 14 8 20 8"></polyline>
                        </svg>

                        Choose File
                    </div>
                </a>

                {!upload && (
                    <span>No File Chosen</span>
                )}

                {upload && (
                    <span>{upload?.fileName}</span>
                )}

                <br />

                {upload && (
                    <>
                        {!readOnly && (
                            <a
                                onClick={clear}
                                style={{
                                    backgroundColor: '#3E67C7',
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px',
                                    borderRadius: '5px',
                                    marginTop: '10px',
                                    textAlign: 'center',
                                    textDecoration: 'none',
                                    marginBottom: '15px',
                                    cursor: 'pointer',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: 15
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-rotate-ccw">
                                        <polyline points="1 4 1 10 7 10"></polyline>
                                        <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>
                                    </svg>

                                    Clear
                                </div>
                            </a>
                        )}
                    </>
                )}
            </div>

            <Dropzone
                disabled={!isRenderedField || isPreview || readOnly}
                accept={{
                    'image/png': 'image/png',
                    'image/jpeg': 'image/jpeg',
                    'image/jpg': 'image/jpg',
                    'image/gif': 'image/gif',
                    'image/bmp': 'image/bmp',
                    'application/pdf': 'application/pdf',
                }}
                ref={dropzoneRef}
                onDrop={
                    (acceptedFiles, fileRejections) => {
                        setError(null)

                        if (fileRejections?.length) {
                            if (fileRejections[0]?.errors[0]?.code === 'file-too-large') {
                                setError('The file you have selected would exceed the maximum file size limit of 5.00 MB.')
                            } else if (fileRejections[0]?.errors[0]?.code === 'file-invalid-type') {
                                setError('This file type is not permitted.')
                            } else {
                                setError('An error occurred while processing the file. Please try again.')
                            }
                        }

                        if (!acceptedFiles || !acceptedFiles?.length) setFile(null)
                        else setFile(acceptedFiles?.[0])
                    }
                }
                maxSize={5* 1024 * 1024}
            >
                {({ getRootProps, getInputProps }) => (
                    <section
                        style={{
                            border: '5px dashed grey',
                            padding: '5px',

                            height: '150px',

                            maxWidth: '800px',
                            maxHeight: '500px',

                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            ...(readOnly && { backgroundColor: 'grey', pointerEvents: 'none ' })
                        }}
                    >
                        <div
                            {...getRootProps()}
                            className="dropzone"
                        >
                            <input
                                {...getInputProps()}
                            />

                            {!upload && isPreview && (
                                <h3>No File Uploaded</h3>
                            )}

                            {!upload && !isPreview && (
                                <h3>No File Uploaded</h3>
                            )}

                            {upload && (
                                <>
                                    <img
                                        src={`${STORAGE_SERVICE_ROOT}public/patient-attachments/${upload?.key}`}
                                        alt="Preview"
                                        style={{
                                            width: '400px',
                                            height: '150px',

                                            objectFit: 'contain',
                                        }}
                                    />
                                </>
                            )}
                        </div>
    
                        {!upload && !upload?.key && (
                            <h5>Maximum upload file size: 5 MB.</h5>
                        )}
                    </section>
                )}
            </Dropzone>

            <br />

            <div className="form-field-label secondary">
                <strong>{sublabel}</strong>
            </div>

            <p>• Only PDF, JPG, PNG, GIF, and BMP formatted images are accepted.</p>
        </div>

        <ValidationMessage message={validationMessage} />
    </>
};

FormFieldPatientAttachment.propTypes = {
    field: PropTypes.object.isRequired,
    isRenderedField: PropTypes.bool,
    onChange: PropTypes.func,
    value: PropTypes.string,
    onBlur: PropTypes.func,
    validationMessage: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.string,
    ]),
    readOnly: PropTypes.bool,
    className: PropTypes.string,
};

FormFieldPatientAttachment.defaultProps = {
    isRenderedField: false,
    onChange: () => { },
    onBlur: () => { },
    readOnly: false,
};

export default FormFieldBase(FormFieldPatientAttachment);